import { SvgIcon } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import type { IconType } from 'react-icons';

type PlaylistModeIconColor = 'action' | 'info' | 'warning' | 'disabled';

type PlaylistModeIconProps = {
  icon: SvgIconComponent | IconType;
  color?: PlaylistModeIconColor;
  size?: number;
};

export function PlaylistModeIcon({ icon: Icon, color = 'action', size = 20 }: PlaylistModeIconProps) {
  if ('muiName' in Icon) {
    const MuiIcon = Icon as SvgIconComponent;
    return (
      <MuiIcon
        fontSize="small"
        color={
          color === 'disabled' ? 'disabled' : color === 'warning' ? 'warning' : color === 'info' ? 'info' : 'action'
        }
        sx={{ fontSize: size, width: size, height: size }}
      />
    );
  }

  const ReactIcon = Icon as IconType;
  const iconColor =
    color === 'disabled'
      ? 'action.disabled'
      : color === 'warning'
        ? 'warning.main'
        : color === 'info'
          ? 'info.main'
          : 'action.active';

  return (
    <SvgIcon
      component={ReactIcon}
      inheritViewBox
      sx={{
        color: iconColor,
        fontSize: size,
        width: size,
        height: size,
        display: 'block',
      }}
    />
  );
}
